module.exports = __webpack_public_path__ + "img/html.be8fca53.png";